import { useEffect, useState } from "react";
import CheckboxGroup from "../../components/Checkbox";
import Input from "../../components/InputBox";
import { getGlobalOptions } from './../../services/auth/selfSignUp';
import { enumGlobalOptionData } from "../../utils/enumGlobalOptionData";
import { convertForCheckbox } from "../../utils/convertApiData";
import { SelfSignUpFields } from "../../utils/enumSelfSignup";
import { toast } from "../../components/AppToast";

const SystemInfo = ({ formData, setFormData }) => {
    const [sysCapOptions, setSysCapOptions] = useState([]);

    const getSysCap = async () => {
        try {
            const data = await getGlobalOptions(enumGlobalOptionData?.SYS_CAP);
            setSysCapOptions(convertForCheckbox(data));
        } catch (err) {
            toast.error(err);
        }
    }

    useEffect(() => {
        getSysCap();
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const isOn = (value) => value === true || value === "yes" || value === "Yes";

    const handleToggle = (name, checked) => {
        setFormData(prev => ({ ...prev, [name]: checked ? "yes" : "no" }));
    };

    return (
        <div className="card_content">
            <h4>Step 5: System Information</h4>
            <p>This page will display system information relevant to the self-sign-up process.</p>
            {/* Additional content can be added here */}
            <div className="card_content">
                <div className="checkbox_group">
                    <span className="label">System Capabilities <span className="required">*</span></span>
                    <CheckboxGroup options={sysCapOptions} name={SelfSignUpFields.TENANT_SYSTEMCAPABILITIES} values={formData?.[SelfSignUpFields.TENANT_SYSTEMCAPABILITIES] || []} onChange={(newValues) => setFormData({ ...formData, tenant_systemCapabilities: newValues })} multiple={true}/>
                </div>
                
                <div className="card_container">
                    {[
                        { label: "WMS System In Use", name: "tenant_wmsSystemInUse" },
                        { label: "ERP System In Use", name: "tenant_erpSystemInUse" },
                    ].map((field) => {
                        const checked = isOn(formData?.[field.name]);
                        return (
                            <div className="input onboarding-system-toggle" key={field.name}>
                                <label className="form-label fw-semibold small" htmlFor={field.name}>{field.label}</label>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id={field.name}
                                        checked={checked}
                                        onChange={(e) => handleToggle(field.name, e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor={field.name}>{checked ? "Yes" : "No"}</label>
                                </div>
                            </div>
                        );
                    })}
                    <Input isRequired className={"input"} label="Number of User Licenses" name={SelfSignUpFields.TENANT_NUMOFUSERLIC} value={formData?.[SelfSignUpFields.TENANT_NUMOFUSERLIC]} onChange={handleChange} />
                </div>
                <CheckboxGroup 
                    options={[ { label: "Integration required", value: "tenant_integrationRequired" } ]} 
                    name="tenant_integrationRequired" 
                    values={formData?.tenant_integrationRequired ? ["tenant_integrationRequired"] : []} 
                    onChange={(newValues, checked) => setFormData({ ...formData, [newValues]: checked })}
                />
            </div>
        </div>
    );
}

export default SystemInfo;